<template>
  <div class="hp-base-panel-wrp hp-base-panel-wrp-box">
    <div class="know-panel">
      <div class="hp-title hp-title-other">
        <em class="left hp-name">预约须知</em>
      </div>
      <ul class="know-list">
        <li class="know-item" v-for="(v, i) in list" :key="`know-item-${i}`">
          <div class="know-item-t">
            <img class="icon" :src="v.icon" />
            <p>{{ v.title }}</p>
          </div>
          <p class="know-item-b">{{ v.desc }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list']
}
</script>

<style lang="scss" scoped>
.hp-base-panel-wrp-box {
  padding-top: 40px !important;
}
.know-panel {
  .hp-title-other {
    position: relative;
    &:before {
      content: '';
      display: block;
      width: 686px;
      height: 1px;
      background-color: #eaeaea;
      margin-top: 16px;
      transform: scaleY(0.5);
    }
  }
  .hp-name {
    position: absolute;
    left: 50%;
    top: -10px;
    transform: translateX(-50%);
    color: #6c798c !important;
    padding: 0 24px;
    background-color: #fff;
  }
  .know-item {
    padding: 20px 0;
    &:last-child {
      padding-bottom: 0;
    }
    &:first-child {
      padding-top: 0;
    }
    &-t {
      display: flex;
      align-items: center;
      .icon {
        display: block;
        width: 18px;
        object-fit: cover;
        margin-right: 10px;
      }
      p {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6c798c;
      }
    }
    &-b {
      margin-top: 20px;
      margin-left: 30px;
      font-size: 22px;
      line-height: 33px;
      color: #9da3ac;
      white-space: normal;
      word-break: break-all;
    }
  }
}
</style>
